import React, { FC } from 'react';
import IComponentProps from 'interfaces/IComponentProps';
import Modal from 'components/Modal';
import Frame from 'components/Frame';
import { useHistory } from 'react-router-dom';

const StreamError: FC<IComponentProps> = () => {
  const history = useHistory();
  return(
    <Frame className='bg'>
      <Modal
        open={true}
      >
        <div>
          웹캠과 마이크를 체크하세요.
        </div>
        <button
          className='btn-cta'
          onClick={() => window.location.reload()}
        >
          첫 화면으로 돌아갑니다.
        </button>
      </Modal>
    </Frame>
  )
}

export default StreamError;